<template>
  <div :id="idName" class="loading_cell">
    <template v-if="status == 1">
      <div />
    </template>
    <template v-if="status == 2">
      <img class="loading_img" src="@/assets/img/loading.gif" alt="" />
      加载中...
    </template>
    <template v-if="status == 3"> 已全部加载 </template>
  </div>
</template>

<script>
export default {
  props: {
    idName: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      status: 2, // 1默认 2加载中 3全部加载完毕
    };
  },
  mounted() {
    const ob = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && this.status === 1) {
            // 加载更多
            this.status = 2;
            this.$emit("getMore");
          }
        }
      },
      {
        threshold: 0, // 重叠阈值
      }
    );

    setTimeout(() => {
      ob.observe(document.querySelector(`#${this.idName}`));
    });
  },
  methods: {
    updateLoading(status) {
      this.status = status;
    },
  },
};
</script>

<style scoped>
.loading_cell {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  color: #999;
  font-size: 12px;
  padding: 5px 0;
}

.loading_img {
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 5px;
}
</style>
